import {
  Box,
  FormControl,
  GridItem,
  Stack,
  Text,
  FormLabel,
  Switch,
} from "@chakra-ui/react";
import React from "react";

const controls = [
  ["Active?", "isActive"],
  ["Free?", "isFree"],
  ["For Sale?", "isForSale"],
];

export interface MarketplaceControlsProps {
  onChange: (key: string, value: boolean) => void;
  marketplaceFlags: {
    isActive: boolean;
    isFree: boolean;
    isForSale: boolean;
  };
}

const MarketPlaceControls = (props: MarketplaceControlsProps): JSX.Element => {
  const { onChange } = props;
  return (
    <GridItem colSpan={{ base: 5, lg: 1 }} position="relative">
      <Box borderWidth={1} p={4} pt={10} borderRadius={5}>
        <Text position="absolute" fontSize="sm" color="gray.500" top={0} pt={2}>
          Marketplace Controls
        </Text>
        <Stack spacing={2}>
          {controls.map(([label, key]) => (
            <FormControl key={key}>
              <FormLabel>{label}</FormLabel>
              <Switch
                isChecked={props.marketplaceFlags[key]}
                onChange={(e) => onChange(key, e.target.checked)}
              />
            </FormControl>
          ))}
        </Stack>
      </Box>
    </GridItem>
  );
};

export default MarketPlaceControls;
